module.exports = __webpack_public_path__ + "static/logo-62496cd2fb3ba44442b9f291f4a6376f.jpg";